import Modal from '../components/modal.js';

export default class ConfirmationModal extends Modal {
  get events() {
    return {
      'click .yes': '_proceed',
      'click .no': '_doNotProceed',
    };
  }

  beforeFilter() {
    this.callbacks = [];
    this.template = 'components/confirmation_modal';
  }

  answer(callback) {
    this.callbacks.push(callback);
  }

  _triggerCallbacks(value) {
    this.callbacks.forEach(function (c) {
      c(value);
    });
  }

  _setupData(data) {
    return data;
  }

  _getTemplate() {
    return '';
  }

  _formatModal() {
    var onePercent = $(window).width() / 100,
      width = 30;

    return {
      top: 180,
      left: onePercent * ((100 - width) / 2),
      width: onePercent * width,
      height: onePercent * width,
    };
  }

  _setupRender(data, selfRender) {
    var style, renderData;

    data = this._setupData(data);
    style = this._formatModal(data);

    this.wait = false;
    this.show({
      top: style.top,
      left: style.left,
    });

    renderData = {
      width: style.width - 20,
      height: style.height,
    };

    if (selfRender) {
      renderData.data = data;
    } else {
      renderData.content = this._getTemplate(data, style);
    }

    // Modals are not following the width specified by who's using it
    // so this is an isolated fix for DEV-8356 ir order to avoid breaking
    // other modals and keep test scope
    if (style.fixedWidth) {
      this.$el.css('width', style.width + 'px');
    }
    if (style.fixedHeight) {
      this.$el.css('height', style.height);
    }
    this.setContent(this.render_template(renderData, this.template));
  }

  _humanizedJoin(list, prefix, suffix) {
    var result = '';

    if (_.isEmpty(list)) {
      return result;
    }

    if (list.length === 1) {
      result = list[0];
    } else if (list.length === 2) {
      result = list[0] + suffix + ' and ' + prefix + list[1];
    } else if (list.length > 2) {
      result = [
        list.slice(0, -1).join(suffix + ', ' + prefix),
        list.slice(-1)[0],
      ].join(suffix + ', and ' + prefix);
    }

    return prefix + result + suffix;
  }

  _proceed() {
    this._triggerCallbacks(true);
  }

  _doNotProceed() {
    this._triggerCallbacks(false);
  }
}
